import React, { FunctionComponent } from 'react'
import { Circle, ClipPath, Defs, G, Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export interface QuestionMarkIconProps {
  width?: string | number
  height?: string | number
  fillColor?: string
  isFilled?: boolean
}

export const QuestionMarkIcon: FunctionComponent<QuestionMarkIconProps> = ({
  width = 14,
  fillColor,
  isFilled = false,
  ...props
}) => {
  const { colors } = useTheme()

  return (
    <Svg width={width} height={width} viewBox='0 0 24 24' {...props}>
      {isFilled ? (
        <>
          <G clipPath='url(#clip0_6302_12976)'>
            <Circle cx={12.7788} cy={12.75} r={10.75} fill={fillColor || colors.iconActive} />
            <Path
              d='M12.899 15.502h-.18a.75.75 0 01-.55-.9 5.68 5.68 0 012-3.07 2.25 2.25 0 10-2.8-3.52 2.24 2.24 0 00-.84 1.74.75.75 0 11-1.5 0 3.75 3.75 0 014.62-3.65 3.69 3.69 0 012.78 2.78 3.75 3.75 0 01-1.31 3.8 4.21 4.21 0 00-1.49 2.24.75.75 0 01-.73.58zM12.779 18.752a1 1 0 100-2 1 1 0 000 2z'
              fill='#fff'
            />
          </G>
          <Defs>
            <ClipPath id='clip0_6302_12976'>
              <Path fill='#fff' transform='translate(.779)' d='M0 0H24V24H0z' />
            </ClipPath>
          </Defs>
        </>
      ) : (
        <>
          <G clipPath='url(#clip0_4233_7716)' fill={fillColor || colors.iconActive}>
            <Path d='M12.899 14.75h-.18a.75.75 0 01-.55-.9 5.68 5.68 0 012-3.07 2.25 2.25 0 10-2.8-3.52 2.24 2.24 0 00-.84 1.74.75.75 0 11-1.5 0 3.75 3.75 0 014.62-3.65 3.69 3.69 0 012.78 2.78 3.75 3.75 0 01-1.31 3.8 4.21 4.21 0 00-1.49 2.24.75.75 0 01-.73.58zM12.779 18a1 1 0 100-2 1 1 0 000 2z' />
            <Path d='M12.779 22.75A10.75 10.75 0 1123.529 12a10.76 10.76 0 01-10.75 10.75zm0-20a9.25 9.25 0 109.25 9.25 9.26 9.26 0 00-9.25-9.25z' />
          </G>
          <Defs>
            <ClipPath id='clip0_4233_7716'>
              <Path fill='#fff' transform='translate(.779)' d='M0 0H24V24H0z' />
            </ClipPath>
          </Defs>
        </>
      )}
    </Svg>
  )
}
